import React, {forwardRef, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {
  ChromelessButton,
  ChromelessButtonProps,
} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {boxShadow} from '../../../../libs/shared/ui/src/theme/themeStyleHelpers';

/*
 * Style.
 */

const StyledAvatarButton = styled(ChromelessButton)`
  position: relative;
  border-radius: 50%;
  ${(p) => boxShadow(p.theme, `0 1px 3px ${p.theme.alphas.black40}`)};
`;

/*
 * Component.
 */

export const AvatarButton = forwardRef<HTMLDivElement, PropsWithChildren<ChromelessButtonProps>>(
  (props, ref) => (
    <StyledAvatarButton {...props} ref={ref}>
      {props.children}
    </StyledAvatarButton>
  ),
);
